/* eslint-disable menti-react/filename-convention--jsx */
import * as React from 'react';
import { colorjoy } from '@mentimeter/sfinx-themes';
import { useOptionalPace } from '../../data-mediation';

const C = colorjoy.background;

export const ColorJoyBackground = () => {
  const slideIndex = useOptionalPace()?.state?.slideIndex ?? 0;
  return <C index={slideIndex} />;
};
